"use client";

import React from 'react';
import { Flex, Heading, Text, Box } from '@chakra-ui/react';

interface CardHeaderProps {
  title: string;
  trend: string;
  trendValue: string;
  trendDirection: 'up' | 'down';
}

const CardHeader: React.FC<CardHeaderProps> = ({ 
  title, 
  trend, 
  trendValue, 
  trendDirection 
}) => {
  const isPositive = trendDirection === 'up';
  const textColor = isPositive ? 'green.700' : 'red.500';

  return (
    <Flex 
      justify="space-between" 
      align="center" 
      pb="1" 
      mb="5"
      flexDir={{ base: 'column', sm: 'row' }}
      gap={{ base: '2', sm: '0' }}
      alignItems={{ base: 'flex-start', sm: 'center' }}
    >
      <Heading as="h1" fontSize="xl" fontWeight="medium" color="black">
        {title}
      </Heading>
      <Flex gap="2" align="center" fontWeight="medium" color={textColor}>
        <Text>{trend} {trendValue}</Text>
        <Box as="span" ml="1">
          {isPositive ? '↑' : '↓'}
        </Box>
      </Flex>
    </Flex>
  );
};

export default CardHeader; 